import { Game } from "../types/game";
import { Rules, User } from "../types/user";

export type RangeHandicapMode = "manual" | "custom" | "automatic";

type RangeGameLike = Pick<Game, "isRangeGame" | "rangeHandicapMode"> | null | undefined;

export const isRangeGame = (game: RangeGameLike): boolean => !!game?.isRangeGame;

export const getRangeHandicapMode = (game: RangeGameLike): RangeHandicapMode => {
  if (!isRangeGame(game)) return "automatic";
  return game?.rangeHandicapMode ?? "automatic";
};

export const usesRhiIndexForHandicap = (game: RangeGameLike): boolean =>
  isRangeGame(game) && getRangeHandicapMode(game) === "automatic";

export const handicapIndexForRangePlay = (user: Pick<User, "rhi" | "hcp">): number =>
  user.rhi ?? user.hcp ?? 0;

export const hasEstablishedRhi = (user: Pick<User, "rhi"> | null | undefined): boolean =>
  user?.rhi != null;

export const canCreateRangeGames = (user: Pick<User, "rule" | "rhiCreatorAllowed"> | null | undefined): boolean => {
  if (!user) return false;
  if (user.rule === Rules.Admin) return true;
  if (user.rule !== Rules.Organiser) return false;
  return !!user.rhiCreatorAllowed;
};
